import * as DKFDS from 'dkfds';

/*global sessionExpirationTime, sessionDialogTime */

export function setupSessionTimer() {
    if (!window.sessionExpirationTime) {
        return;
    }

    const openTimer = setInterval(openDialog, 1000);
    let secondsRemaining;

    function openDialog() {
        const now = Date.now();
        if (now > sessionDialogTime) {
            clearInterval(openTimer);
            new DKFDS.Modal(document.getElementById('sessionTimeoutModal')).show();
            updateDialog();
        }
    }

    function updateDialog() {
        const now = Date.now();
        if (now > sessionExpirationTime) {
            new DKFDS.Modal(document.getElementById('sessionTimeoutModal')).hide();
            window.location = window.location.origin + '/?sessionTimeout';
        }
        else {
            const secs = Math.floor((sessionExpirationTime - now) / 1000);
            if (secs !== secondsRemaining) {
                secondsRemaining = secs;
                const minutes = Math.floor(secs / 60);
                const seconds = secs % 60;
                const str = minutes > 0 ? `${minutes} min. ${seconds} sek.` : `${seconds} sek.`;
                window.sessionCountDownArea.innerHTML = `<strong>Du bliver automatisk logget ud om ${str}</strong>`;
            }
            setTimeout(updateDialog, 100);
        }
    }
}